(function () {
  var CM_PER_INCH = 2.54;

  /* Round to the nearest half inch — matches how size charts are normally written */
  function cmToInches(cm) {
    return Math.round((cm / CM_PER_INCH) * 2) / 2;
  }

  /* Handles single values ("34"), ranges ("78.5-86" / "78.5–86") and blanks */
  function convert(raw, unit) {
    if (raw === null || raw === undefined) return '';
    var text = String(raw).trim();
    if (text === '') return '';
    if (unit === 'cm') return text;

    var parts = text.split(/\s*[-–—]\s*/);
    var converted = parts.map(function (part) {
      var n = parseFloat(part.replace(',', '.'));
      if (isNaN(n)) return part;
      return cmToInches(n);
    });

    return converted.join('–');
  }

  /* ---------- Modal helpers (shared, so remote triggers can use them) ---------- */
  var lastFocused = null;

  function openPanel(root) {
    var panel = root.querySelector('[data-sg-panel]');
    var overlay = root.querySelector('[data-sg-overlay]');
    var closeBtn = root.querySelector('[data-sg-close]');
    if (!panel) return;

    lastFocused = document.activeElement;
    panel.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.classList.add('sg-open');
    if (closeBtn) closeBtn.focus();
  }

  function closePanel(root) {
    var panel = root.querySelector('[data-sg-panel]');
    var overlay = root.querySelector('[data-sg-overlay]');
    if (!panel) return;

    panel.hidden = true;
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('sg-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function findModalRoot() {
    var roots = document.querySelectorAll('[data-sg]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].querySelector('.sg__panel--modal')) return roots[i];
    }
    return null;
  }

  function initSizeGuide(root) {
    if (root.dataset.sgReady === 'true') return;
    root.dataset.sgReady = 'true';

    /* ---------- Unit toggle ---------- */
    var unitButtons = root.querySelectorAll('[data-sg-unit]');
    var cells = root.querySelectorAll('[data-sg-cm]');

    function setUnit(unit) {
      unitButtons.forEach(function (btn) {
        var active = btn.getAttribute('data-sg-unit') === unit;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      cells.forEach(function (cell) {
        cell.textContent = convert(cell.getAttribute('data-sg-cm'), unit);
      });
    }

    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setUnit(btn.getAttribute('data-sg-unit'));
      });
    });

    /* ---------- Body / garment tabs ---------- */
    var groupTabs = root.querySelectorAll('[data-sg-group-tab]');
    var groupBlocks = root.querySelectorAll('[data-sg-group]');
    var groupNotes = root.querySelectorAll('[data-sg-group-note]');

    function setGroup(group) {
      groupTabs.forEach(function (tab) {
        var active = tab.getAttribute('data-sg-group-tab') === group;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      groupBlocks.forEach(function (block) {
        block.hidden = block.getAttribute('data-sg-group') !== group;
      });

      groupNotes.forEach(function (note) {
        note.hidden = note.getAttribute('data-sg-group-note') !== group;
      });
    }

    groupTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setGroup(tab.getAttribute('data-sg-group-tab'));
      });
    });

    /* ---------- Modal (built-in button, overlay, close, Esc) ---------- */
    var openBtn = root.querySelector('[data-sg-open]');
    var closeBtn = root.querySelector('[data-sg-close]');
    var overlay = root.querySelector('[data-sg-overlay]');
    var panel = root.querySelector('[data-sg-panel]');

    if (openBtn) {
      openBtn.addEventListener('click', function () { openPanel(root); });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closePanel(root); });
    }
    if (overlay) {
      overlay.addEventListener('click', function () { closePanel(root); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) closePanel(root);
    });
  }

  /* ---------- Remote triggers (e.g. the Size guide link block) ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-sg-open-remote]') : null;
    if (!trigger) return;
    var root = findModalRoot();
    if (root) {
      e.preventDefault();
      openPanel(root);
    }
  });

  function initAll() {
    document.querySelectorAll('[data-sg]').forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();